module.exports = "<div data-component=\"breadcrumb\" class=\"non-printable\">\n\t<mc-breadcrumbs></mc-breadcrumbs>\n</div>\n\n<!-- https://github.com/McNull/ngx-breadcrumbs -->\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/breadcrumb/breadcrumb.component.html
// module id = ../../../../../src/app/shared/breadcrumb/breadcrumb.component.html
// module chunks = main